import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import './index.scss';

// Import images from local directory
import aqIcon from '../../images/home/aq.png';
import zcIcon from '../../images/home/ac.png'; // Assuming 'ac.png' or 'df.png' is the register/login icon based on context. Will check boxList keys. Let's map properly below.
import gdIcon from '../../images/home/gd.png';
import lqIcon from '../../images/home/lq.png';
import topIcon from '../../images/home/topIcon.png';
import kfIcon from '../../images/home/kf.png';

const icons = {
  aq: <img src={aqIcon} alt="账户安全" className="menu-icon" />,
  zc: <img src={zcIcon} alt="注册登录" className="menu-icon" />, // Assuming zc corresponds to ac.png (account)
  gd: <img src={gdIcon} alt="发单跟单" className="menu-icon" />,
  lq: <img src={lqIcon} alt="聊球" className="menu-icon" />
};

function Home(props) {
	const history = useHistory();
	const [boxList, setBoxList] = useState([
		{
			key: 'aq',
			value: '账户安全',
			url: '/account_security.html'
		},
		{
			key: 'zc',
			value: '注册登录',
			url: '/registe_login.html'
		},
		{
			key: 'gd',
			value: '发单跟单',
			url: '/follow_bet.html'
		},
		{
			key: 'lq',
			value: '聊球',
			url: '/chat_ball.html'
		}
	]);
	const [listCurrent, setListCurrent] = useState(1);
	const [param, setParam] = useState('');
	const [aid, setAid] = useState('0');

	useEffect(() => {
		window.document.title = '帮助中心';
		if (window.location.search) {
			const temp = window.location.search.split('serviceUrl=')[1];
			let splitAid = window.location.search.split('f_aid=')[1];
			let aid = splitAid ? splitAid.substring(0,splitAid.indexOf('&')) : '0';
			setParam(temp);
			setAid(aid);
		}
	}, []);

	const changeCurrent = (value) => {
		if (value === listCurrent) {
			setListCurrent(0);
		} else {
			setListCurrent(value);
		}
	}

	const renderItem = () => {
		return boxList.map((item, index) => (
			<a className='box-item' href={item.url} key={index}>
				<div className="icon-wrapper">
					{icons[item.key] || <i className={`icon spr icon-${item.key}`}></i>}
				</div>
				<span className='tit'>{item.value}</span>
			</a>
		));
	}

	return (
		<div className="main-wrapper">
			<div className="header-bg"></div>
			
			{/* Top Navigation Bar */}
			<div className="nav-bar">
				{/* <div className="back-btn" onClick={() => history.goBack()}>
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<polyline points="15 18 9 12 15 6"></polyline>
					</svg>
				</div> */}
				{/* <div className="title">帮助中心</div> */}
				<div className="placeholder"></div>
			</div>

			{/* Greeting Section */}
			<div className="greeting-sec">
				<div className="text-part">
					<div className="hi">Hi~</div>
					<div className="sub">有什么可以帮到您!</div>
				</div>
				<div className="robot-icon">
					<img src={topIcon} alt="robot" />
				</div>
			</div>

			<section className="main">
				<div className='box-main-div'>
					<div className='box'>
						{renderItem()}
					</div>
				</div>

				<div className='list-main-div'>
					<div className='title-div'>
						<h2 className='title'>常见问题</h2>
					</div>
					<div className='item-div' onClick={() => changeCurrent(1)}>
						<div className={listCurrent===1?'item-title open-title':'item-title'}>
							忘记登录密码了怎么办？
						</div>
						{listCurrent === 1 && (
							<div className='item-content'>
								<p>可通过找回密码功能重置登录密码，流程如下：</p>
								<p>1. 点击“我的”，进入登录页面的密码登录；</p>
								<p>2. 点击“忘记密码”；</p>
								<p>3. 填写手机号码后提交；</p>
								<p>4. 填写手机号码接收到的验证码；</p>
								<p>5. 设置新的登录密码。</p>
							</div>
						)}
					</div>
					<div className='item-div' onClick={() => changeCurrent(2)}>
						<div className={listCurrent===2?'item-title open-title':'item-title'}>
							收不到验证码怎么办？
						</div>
						{listCurrent === 2 && (
							<div className='item-content'>
								<p>请检查是否存在以下情况：</p>
								<p>1. 点击“获取验证码”后，倒计时显示是否正常，若不正常，请稍后重试；</p>
								<p>2. 手机号码是否填写正确；</p>
								<p>3. 检查短信是否被手机管家等软件拦截，可在拦截信息中查看；</p>
								<p>4. 是否被运营商列入黑名单；</p>
								<p>5. 手机信号是否正常；</p>
								<p>6. 是否发送验证码次数过多，若5分钟内超过3次，请间隔5分钟再次尝试；若1小时内超过5次，请间隔1小时后重试；若一天内超过15次，请于第二天再次尝试；</p>
								<p>若仍未能解决您的问题，请稍后重试或联系本站客服处理。</p>
							</div>
						)}
					</div>
				</div>
			</section>

			{/* Floating Action Button for Service */}
			<a href={`${param}`} title="在线客服" className="btnServer">
				<img src={kfIcon} alt="在线客服" />
			</a>
		</div>
	)
}

export default Home;
